<template>
  <div class="wrapper">
    <CRow class="mt-3">
      <CCol sm="12" lg="4" >
        <CCard>
          <CCardHeader> 
            <b> Article Form </b> 
          </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol>
                  <CRow >
                    <CCol >
                      <label> Title </label>
                      <b-input
                        v-model="form.title"
                        placeholder="Title"
                        id="feedback-user"
                        class="mb-1"
                        :class="errors.title ? 'is-invalid' : ''"
                      >
                      </b-input>
                      <b-form-invalid-feedback >
                        Your title must be filled
                      </b-form-invalid-feedback> 
                    </CCol>
                  </CRow>
                  <CRow class="mt-3">
                    <CCol >
                      <label> Subtitle </label>
                       <b-input
                        v-model="form.subtitle"
                        placeholder="subtitle"
                        id="feedback-user"
                        class="mb-1"
                        :class="errors.subtitle ? 'is-invalid' : ''"
                      >
                      </b-input>
                      <b-form-invalid-feedback >
                        Your Subtitle must be filled
                      </b-form-invalid-feedback> 
                    </CCol>
                  </CRow> 
                </CCol>
              </CRow>
            </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="12" lg="8">
        <CCard>
          <CCardHeader> 
            <b> Image </b> 
          </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol>
                    <CRow >
                      <CCol>
                        <label> Card Image </label>
                      </CCol>
                      <CCol>
                        <label> Background Image </label>
                      </CCol>
                    </CRow>
                      <CRow>
                        <CCol>
                          <CRow class="mb-4">
                            <CCol>
                              <img v-if="btn_create" v-bind:src="getPhoto(form.card_image)" width="200px" height="130px">
                              <img v-bind:src="form.card_image" style="width:200px"/>
                              <b-form-file class="mt-1" v-if="btn_create" v-model="form.card_image"  plain></b-form-file>
                              <CButton  class="mt-2 ml-3" v-if="btn_update" type="button" @click="openModalPhotoCardImage(form.id)"  variant="outline" color="info">Change Image</CButton>
                            </CCol>
                            <CCol >
                              <CRow class="mb-3">
                                <CCol>
                                  <img v-if="btn_create" v-bind:src="getPhoto(form.bg_image)" width="200px" height="130px">
                                  <img v-bind:src="form.bg_image" style="width:200px"/>
                                  <b-form-file class="mt-1" v-if="btn_create" v-model="form.bg_image"  plain></b-form-file>
                                  <CButton  class="mt-2 ml-3" v-if="btn_update" type="button" @click="openModalPhotoBGImage(form.id)"  variant="outline" color="info">Change Image</CButton>
                                </CCol>
                              </CRow>
                            </CCol>
                          </CRow>
                        </CCol>
                      </CRow> 
                </CCol>
              </CRow>
            </CCardBody>
        </CCard>
         <CButton v-if="btn_create " block type="submit" v-on:click.prevent="create()"   color="info"><b>Create </b></CButton>
        <CButton v-if="btn_update" block type="submit" v-on:click.prevent="update(form.id)"   color="info">Update</CButton>
      </CCol>
    </CRow>
    <br><br>
    <alertmodal></alertmodal>
    <modalphotobg></modalphotobg>
    <modalphotocard></modalphotocard>
    <!-- <pre>{{ $data | json }}</pre> -->
  </div>
</template>

<script>
import axios from 'axios'
import EventBus from '@/eventBus';
import alertmodal from '@/views/alert/modal.vue';
import modalphotocard from './article_modal_photo_bgimage.vue';
import modalphotobg from './article_modal_photo_cardimage.vue';
import articlecategory from '@/services/articlecategory'



export default {
name: 'articleform',
  components: { 
    alertmodal,
    modalphotocard,
    modalphotobg,
  },
  data () {
    return {
      errors: {},
      errors_from_backend: [],
      loading: false,
        form:{
            id: '',
            title: '',
            subtitle:'',
            card_image:'',
            bg_image:'',
        },
        options: [
         
          
        ],
        btn_create: 0,
        btn_update: 0,
       
        
      
    }
  },
   computed: {
   },
  mounted(){
    this.loadData()
    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });
    

  },

  beforeDestroy() {
    // removing eventBus listener
    EventBus.$off('TABLE_UPDATE')
  },
  
  created () {

  },
  methods: {
      loadData(){
        if(this.$route.query.id){
            this.btn_update = 1;

              articlecategory.getArticleCategorybyID(this.$route.query.id)
              .then(res => {
                  this.form.id = res.data.id;
                  this.form.title = res.data.title;
                  this.form.subtitle = res.data.subtitle;
                  this.form.bg_image = res.data.bg_image;
                  this.form.card_image = res.data.card_image;
                //this.form.mobile_setting = !empty(res.data.mobile_setting) ? JSON.parse(res.data.mobile_setting) : '';
            }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
            })
        }else{
            this.btn_create = 1;

        }
       
      
      },

    create(){
      let formData = new FormData();
      formData.append('title', this.form.title );
      formData.append('subtitle', this.form.subtitle );
      formData.append('bg_image', this.form.bg_image );
      formData.append('card_image', this.form.card_image );
      this.loading = true;
      if (this.check_form()) {
      articlecategory.createArticleCategory(formData)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        setTimeout(() => {  this.$router.push({name:'Article Category Table' }) }, 1500);
        this.show = false;
      }).catch((err) => {
        this.loading = false;
        alert(err.response.data.message);
        //alert(JSON.stringify(err.response.data.errors));
        if (err.response.data.errors != null) {
            this.errors_from_backend = err.response.data.errors;
            console.log(JSON.stringify(err.response.data.errors));
        }
          });
      }else{
      this.loading = false;
      }
    },
    update(id){
       let formData = new FormData();
      formData.append('title', this.form.title );
      formData.append('subtitle', this.form.subtitle );
      formData.append('bg_image', this.form.bg_image );
      formData.append('card_image', this.form.card_image );
      
      articlecategory.updateArticleCategory(id, formData)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    getImage(url){
        if (url){
          return url;
        }else{
          return '';
        }
    },

    openModalPhotoBGImage(id){
        var params = {title: 'Update BG Image', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_EVENT_PHOTO_BGIMAGE_ARTICLE', params)
        console.log('load modal photo')      
    },
    openModalPhotoCardImage(id){
        var params = {title: 'Update Card Image', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_EVENT_PHOTO_CARDIMAGE_ARTICLE', params)
        console.log('load modal photo')      
    },

      getPhoto(data){
      console.log('get - photo')
        if (data){
            return axios.defaults.baseURL + '/getfile/' + data.path + '/' + data.filename
        }else{
            return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
        } 
     
    }, 
    check_form: function(e) {
         this.errors = {};
         if (!this.form.title) {
            this.errors["title"] = "1";
         }
         if (!this.form.subtitle) {
            this.errors["subtitle"] = "1";
         }

         if (
            this.form.title &&
            this.form.subtitle
         ) {
            return true;
         } else {
            return false;
         }
      },
      

  }
}


</script>
<style>

h1 {
	height: 120px;
	line-height: 120px;
	text-align: center;
}
.vc-chrome {
	position: absolute;
	top: 35px;
	right: 0;
	z-index: 9;
}
.current-color {
	display: inline-block;
	width: 16px;
	height: 16px;
	background-color: #000;
	cursor: pointer;
}
.footer {
	margin-top: 20px;
	text-align: center;
}
</style>